// Mock data for Coaching Daniel et Moi - parenting book presale landing page

export const HERO_IMAGE =
  "https://images.pexels.com/photos/3889822/pexels-photo-3889822.jpeg";

export const HERO_BOOK_IMAGE =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_website-builder-2158/artifacts/1a51ead3e3db0c15_ChatGPT%20Image%20Oct%2021%2C%202026%2C%2001_09_38%20AM.png";
export const COACH_IMAGE =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_website-builder-2158/artifacts/9ae809bc2cb2247f_IMG_4669.JPEG";

export const GIFT_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/6270ab13-5db1-4dbc-896b-7a627ac95fdc/images/ca29e662d5284103f9ded0b060376e581f22704152d3f31c0c5e96863e177be0.jpeg";

export const bonusDownloads = [
  {
    id: "toolkit",
    title: "When Nothing Works — The Response-Ready Parenting Toolkit",
    type: "E-Book · PDF",
    file: "/downloads/When-Nothing-Works-Response-Ready-Parenting-Toolkit.pdf",
  },
  {
    id: "phrases",
    title: "7 Calming Phrases Cheat Sheet",
    type: "Cheat Sheet · PDF",
    file: "/downloads/7-Calming-Phrases-Cheat-Sheet.pdf",
  },
];

export const BOOK_IMAGE =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_website-builder-2158/artifacts/4pz0sne3_image.png";

export const navLinks = [
  { label: "About Me", href: "#about" },
  { label: "The Book", href: "#book" },
  { label: "Why This Matters", href: "#why" },
  { label: "Speaking", href: "#speaking" },
  { label: "FAQ", href: "#faq" },
];

export const heroChecklist = [
  "Early bird price",
  "Exclusive bonuses",
  "First access when it's released",
  "Behind-the-scenes updates",
];

export const heroFeatures = [
  { icon: "Heart", label: "Real-life\nstrategies" },
  { icon: "Users", label: "Stronger\nconnection" },
  { icon: "ShieldCheck", label: "Confident,\nresilient kids" },
];

export const bannerItems = [
  { icon: "Sun", label: "Less yelling,\nless guilt" },
  { icon: "Home", label: "More connection,\nmore calm" },
  { icon: "Smile", label: "Kids who feel\nseen and secure" },
];

export const bookFeatures = [
  {
    icon: "Brain",
    title: "1. Understand Why You React Under Pressure",
    text: "Discover why knowing better doesn't always mean responding better.",
  },
  {
    icon: "Activity",
    title: "2. Recognize Your Stress Before You React",
    text: "Notice your warning signs before frustration takes over.",
  },
  {
    icon: "Eye",
    title: "3. Discover Your Parenting-Under-Pressure Pattern",
    text: "Understand what happens to you when parenting gets hard.",
  },
  {
    icon: "HeartHandshake",
    title: "4. Respond Calmly in Hard Moments",
    text: "Learn three simple moves to return to when emotions run high.",
  },
  {
    icon: "ShieldCheck",
    title: "5. Set Boundaries Without Power Struggles",
    text: "Hold firm limits while protecting connection with your child.",
  },
  {
    icon: "MessageCircle",
    title: "6. Communicate So Your Child Understands",
    text: "Give clearer instructions and reduce unnecessary conflict.",
  },
  {
    icon: "HandHeart",
    title: "7. Support Without Rescuing",
    text: "Help your child grow without stepping in to fix everything.",
  },
  {
    icon: "Home",
    title: "8. Move From Guilt to Greater Connection",
    text: "Begin replacing regretted reactions with intentional responses.",
  },
  {
    icon: "RefreshCw",
    title: "9. Break the Cycle of Reactive Parenting",
    text: "Learn to recognize familiar patterns, interrupt automatic reactions, and create healthier connections with your children.",
  },
];

export const bonusItems = [
  "When Nothing Works — The Response-Ready Parenting Toolkit (E-Book)",
  "7 Calming Phrases Cheat Sheet (PDF)",
  "Private Launch Day Livestream",
];

export const testimonials = [
  {
    text: "Rachelle brings so much clarity, warmth and real-life wisdom. Our audience left feeling seen, supported and empowered. The feedback we received after her session was unlike anything we have seen at this conference. She is the kind of speaker you build an event around.",
    author: "Didier G., Event Host, Benin",
  },
  {
    text: "Rachelle does not talk about parenting from the outside. She has lived it, and your audience feels that from the first minute. It was a truly transformational workshop. What she gave our parents were not tips. They were tools so practical and so specific that families were using them the same evening.",
    author: "Noël H., School Principal, Benin",
  },
  {
    text: "Rachelle connected with the women in the audience. Her examples and testimonies resonated with everyone. She made them feel seen and helped them understand that breakthrough is possible. That combination is everything.",
    author: "Eveline S., Conference Host, Canada",
  },
  {
    text: "Before working with Rachelle, I already knew a lot about parenting, but in challenging moments, it was hard to put that knowledge into practice. During the five-day course, she helped me recognize my body's warning signal before a reaction took over. Now, I feel better equipped to pause, understand what my kids need, and respond with intention.",
    author: "H. Baker, Parent, Canada",
  },
  {
    text: "I often stepped in too quickly to rescue my children instead of giving them space to figure things out. Working with Rachelle helped me become aware of that pattern. During a conversation with my daughter, I caught myself wanting to rescue her and was able to step back and respond differently.",
    author: "Marlene M., Parent, Canada",
  },
  {
    text: "I was not sure how to set boundaries with my boys without relying on correction. Through working with Rachelle, I developed a better understanding of correction and learned how I could still maintain connection with my children even while setting limits and guiding their behaviour.",
    author: "Raphaelle N., Parent, Canada",
  },
  {
    text: "I used to become frustrated easily, especially when facing challenges in the classroom. I began responding with more calm and repeating instructions gently instead of raising my voice. By the second day, I could already feel the difference—the children listened to me better than before.",
    author: "SOSSOU K. Innocent, Teacher, Benin",
  },
  {
    text: "My children rarely went to bed before 10 p.m. Through the training, I learned to replace harshness with connection and firmness. They now go to bed at 9:30 p.m. and wake up on their own. Since then, I have stopped yelling and hitting. So many things have changed positively.",
    author: "Mme GBEDA Martine, Parent, Benin",
  },
  {
    text: "I struggled to spend quality time with my children and to manage my reactions in difficult family moments. Through the coaching, I began developing more self-control and creating more opportunities for meaningful connection with my children. One of the biggest signs of change was seeing how happy my young son was when we spent more time together.",
    author: "Faustin K., Parent, Ivory Coast",
  },
  {
    text: "Before working with Rachelle, one of my biggest struggles was getting my five-year-old to listen better. After working together, there was more calm and my child began listening more. I knew something had shifted when I felt like I could see what was happening more clearly and from a different perspective. I would recommend Rachelle to a mom who wants to become the best mother she can be for her child.",
    author: "Roxy B.",
  },
  {
    text: "Before working with Rachelle, getting out of the house on time often ended in conflict. I realized that my own reactions to stress were sometimes making things worse. Through our work together, I learned to recognize my body's warning signals and catch myself before saying something I would regret. I recommend Rachelle to moms who feel overwhelmed and often feel like they're failing, especially those who struggle to give themselves the same grace they give others.",
    author: "Sherry-Lynn Bursey",
  },
  {
    text: "Before working with Rachelle, I struggled with helping my children without stepping in and doing things for them. One of the biggest changes for me was learning a different way to give instructions to my children. I knew something had shifted when they were able to understand and do what I was asking them to do. I would recommend Rachelle to parents who are experiencing communication difficulties with their children.",
    author: "Marceline",
  },
];

export const faqs = [
  {
    q: "What's the difference between the Book and the Book + Workbook?",
    a: "The book helps you understand why reactions take over under pressure and what your child needs underneath the behaviour. The workbook is where you apply it. It walks you through your own triggers, warning signals, boundaries and family moments, one page at a time. Reading shows you what's happening. Practising is how it starts to change.",
  },
  {
    q: "Which option should I choose?",
    a: "If you want to understand the pattern, the book is a good place to start. If you want to change how you respond in your own home, choose the Book + Workbook. For $10 more, the ideas in the book become steps you can actually work through.",
  },
  {
    q: "How will my order ship?",
    a: "Both the book and the workbook are printed. If you choose the Book + Workbook, they ship together in one package. You enter your shipping address at checkout, and your order ships at launch.",
  },
  {
    q: "When will the book be released?",
    a: "The book is launching soon. Presale orders ship at launch, and we'll email you the release date as soon as it's set.",
  },
  {
    q: "What do I get by preordering now?",
    a: "Every preorder, book or bundle, includes the presale bonuses: the When Nothing Works e-book, the 7 Calming Phrases Cheat Sheet, and access to the private launch day livestream. The e-book and cheat sheet are ready to download right after checkout, and the livestream invite arrives by email.",
  },
  {
    q: "Can I order more than one copy?",
    a: "Yes. Use the quantity selector in the order form. Many parents order an extra copy for a partner, a friend, or a teacher.",
  },
  {
    q: "Is this book right for me?",
    a: "If you're a working parent or educator who wants calmer days, fewer power struggles, and confident, emotionally resilient kids, without guilt or burnout, this book was written for you.",
  },
];

export const bundleCompare = {
  book: [
    "Why reactions take over when pressure builds",
    "What your child needs underneath the behaviour",
    "The Response-Ready approach, explained step by step",
  ],
  bundle: [
    "Guided pages to spot your own triggers and warning signals",
    "Space to plan boundaries you can hold calmly",
    "Prompts to work through real moments from your week",
    "A record of what's changing, so you can see your progress",
  ],
};

export const SPEAKER_URL = "https://koulrachellespeaks.com/en";
export const SPEAKER_IMAGE =
  "https://customer-assets-jai6qajn.emergentagent.net/job_talk-scheduler-2/artifacts/fwkgewyn_940e3a64-c505-4c09-ab24-906cdf432d5b%20%281%29.JPG";
export const speakingTopics = [
  "Calm Is a Skill, Not a Trait",
  "From Reacting to Responding",
  "Raising Resilient Kids",
  "Breaking the Cycle",
  "Career and Kids",
  "Empowering Educators",
];
